const CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

// Función para ENCRIPTAR
const encodeId = (hexId) => {
    try {
        let bigInt = BigInt("0x" + hexId); // eslint-disable-line no-undef
        let result = '';
        const ZERO = BigInt(0); // eslint-disable-line no-undef
        const BASE = BigInt(62); // eslint-disable-line no-undef

        while (bigInt > ZERO) {
            const remainder = bigInt % BASE;
            result = CHARS[Number(remainder)] + result;
            bigInt = bigInt / BASE;
        }
        return result || '0';
    } catch (error) {
        console.error("Error encodeId:", error);
        return hexId;
    }
};

const decodeId = (base62Id) => {
    try {
        let bigInt = BigInt(0); // eslint-disable-line no-undef
        const BASE = BigInt(62); // eslint-disable-line no-undef
        for (let i = 0; i < base62Id.length; i++) {
            const char = base62Id[i];
            const value = BigInt(CHARS.indexOf(char)); // eslint-disable-line no-undef
            bigInt = bigInt * BASE + value;
        }

        let hex = bigInt.toString(16);

        return hex.padStart(24, '0');
    } catch (error) {
        console.error("Error decodeId:", error);
        return null;
    }
};

export { encodeId, decodeId };